import React from "react";
import { ReplaySubject, Subject } from "rxjs";
import { NotificationParams, AlertLevel, INotificationService, NotificationPayload } from "../models/notification";

export class NotifierService implements INotificationService {
	public notifications = new ReplaySubject<NotificationPayload>(1);

	protected createPayload(
		level: AlertLevel,
		message: string,
		children?: React.ReactNode,
		params?: NotificationParams
	): NotificationPayload {
		return { message, level, children, ...params };
	}

	public success(message: string, children?: React.ReactNode, params?: NotificationParams): void {
		this.notifications.next(this.createPayload("success", message, children, params));
	}

	public info(message: string, children?: React.ReactNode, params?: NotificationParams): void {
		this.notifications.next(this.createPayload("info", message, children, params));
	}

	public error(message: string, children?: React.ReactNode, params?: NotificationParams): void {
		this.notifications.next(this.createPayload("error", message, children, params));
	}

	public warning(message: string, children?: React.ReactNode, params?: NotificationParams): void {
		this.notifications.next(this.createPayload("warning", message, children, params));
	}

	public alertWithDescription(
		level: AlertLevel,
		message: string,
		description: string | React.ReactNode,
		expandDescriptionLink?: string,
		params: NotificationParams = { autoHideDuration: 999999 }
	): void {
		this.notifications.next({
			...this.createPayload(level, message, undefined, params),
			description,
			expandDescriptionLink,
		});
	}
}

const Singleton = (() => {
	let _alertService: NotifierService;

	return {
		getInstance: (): NotifierService => {
			if (!_alertService) {
				_alertService = new NotifierService();
			}
			return _alertService;
		},
	};
})();

export default Singleton.getInstance();
